export default "__VITE_ASSET__BRz7WlRi__"